import React, { Component } from 'react';
import {
    Col, InputGroup, Input,
    FormGroup, Label, InputGroupAddon, InputGroupText, Row
} from 'reactstrap';
import './fields.css'
import axios from "axios";
import driver from '../../assets/Images/driver.jpg';
import uploadFileIcone from '../../assets/Images/upload-button.png';


import { API_ENDPOINT } from '../../../src/AppConfig'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showLoading, hideLoading } from 'react-redux-loading-bar'

class CustomInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imagePreviewUrl: null,
            fileSelected: null,
            previouslang: null,
            previousuri: null,
            uploadedfile: true,

        }

    }
    handleCheckChange = (e, id) => {
        // console.log("handleCheckChange :", e.target.name, e.target.checked)
        if (e.target.name === "all") {
            this.Check(e.target.checked)
        } else {
            if (e.target.checked) {
                this.props.handlepush(id)
            }
            else {
                // console.log("handleCheckChange remove:", id)
                this.props.handleremove(id)
            }
        }

    }
    InputhandleChange(e, input, type) {
        //const re = /^[0-9\b]+$/;
        const re = /^[0-9]+$/
        const ch = String.fromCharCode(e.which);
        const characters = /^[a-z,ا-ى]+$/
        if (type === "number") {
            console.log("typeeeeeeeeeeeeeeeeeee : ", type, !(re.test(ch)));
            if (e.target.value == ' ' || !(re.test(ch))) {
                e.preventDefault();
                input.onChange(e)
                this.setState({ object: e.target.value })
            }
        } if (type === "personName") {
            console.log("typeeeeeeeeeeeeeeeeeee : ", type, !(characters.test(ch)));
            if (e.target.value == ' ' || !(characters.test(ch))) {
                e.preventDefault();
                input.onChange(e)
                this.setState({ object: e.target.value }, () => { console.log("Characteeeeers:", this.state.object) })
            }
        }
        else {
            input.onChange(e)
            this.setState({ object: e.target.value })
        }
    }
    Check(check) {
        if (check) {
            // console.log("handleCheckChange : Check",check)

            this.state.object.map(elment => this.props.handlepush(elment.id))
        }
        else {
            // console.log("handleCheckChange : unCheck",check)
            this.props.handleremove("all")
            // this.state.object.map(elment => this.props.handleremove(elment.id))
        }
        var x = document.getElementsByClassName("checkbox");
        for (let i = 0; i < x.length; i++) {
            x[i].checked = check;
        }
    }
    fetchRequest(uri, lang) {
        let token = 'Bearer ' + this.props.token
        let url = `${API_ENDPOINT}` + uri
        console.log("select url", url, lang)
        axios.get(url, {
            headers: {
                Authorization: token,
                "Accept-Language": lang
            }
        })
            .then(response => {
                const info = response.data.data;

                this.setState({ object: info, previousuri: uri }, () => {
                    console.log("response:", this.state.object)
                });
            }).catch(error => {
                // console.log("error:", error.response);
            })
    }
    handleChange(e, input) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        // this.setState({ fileSelected: file.name })
        reader.onloadend = () => {
            input.onChange(file);
            this.setState({
                file: file,
                fileSelected: file.name,
                imagePreviewUrl: reader.result
            });
        }
        if (file) {
            reader.readAsDataURL(file)
        }
    }
    componentWillMount() {
        this.setState({ uploadedfile: false })
        console.log("Enter imagePreview:", this.props.Fileimagepreview)
        if (this.props.Fileimagepreview) {
            let imageurl = API_ENDPOINT + this.props.Fileimagepreview
            this.setState({ imagePreviewUrl: imageurl })
            // console.log("imagePreviewUrl:", this.state.imagePreviewUrl)
        }
        this.setState({ previouslang: this.props.lang })
        if (this.props.uri) {
            // console.log("URL:", this.props.uri)
            this.fetchRequest(this.props.uri, this.props.lang)
        }

    }
    render() {
        const { lang, display, parentKey, section, placeholder, uploaded, child, input, name, options, optioncustom, type, icone, size, title, label, keyId, keyElement, optionTitle, filetype, inputType, meta: { touched, error } } = this.props
        console.log("input Result in field======>", input.value)

        const object = this.state.object
        let { imagePreviewUrl, fileSelected } = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            if (uploaded === "image") {
                $imagePreview = (<img src={imagePreviewUrl} alt="category" />);
            } else {
                $imagePreview = fileSelected
            }
        }
        if (imagePreviewUrl) {
            if (uploaded === "user") {
                $imagePreview = (<img src={imagePreviewUrl} alt="user" />);
            } else {
                $imagePreview = fileSelected
            }
        }
        if (this.state.previouslang !== this.props.language && this.props.uri) {
            this.setState({ previouslang: this.props.lang })
            this.fetchRequest(this.props.uri, this.props.language)
        }
        // console.log("previous uri", this.state.previousuri, "Uri", this.props.uri)
        if (this.state.previousuri !== this.props.uri) {
            // console.log(" in if previous uri", this.state.previousuri, "Uri", this.props.uri)
            this.setState({ previousuri: this.props.uri })
            this.fetchRequest(this.props.uri, this.props.language)
        }

        return (
            <Col lg={size ? size.lg : "12"} md={size ? size.md : "12"}>

                <FormGroup>
                    <div>
                        <InputGroup>
                            <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"} id={
                                uploaded === "user" ? "changeImageLabel" : ""
                            }
                                style={{ display: display }}>{uploaded === "user" ? <i className="fas fa-pen"></i> : label}</Label>
                            {/* Radio Button Input */}
                            {(type === "radio") &&
                                <div className="checkboxlabel">
                                    <div style={{ display: "inline-block", paddingTop: label ? "" : "2rem" }}>
                                        <Input  {...input} type={type} name={name} />{' '}<span>{title}</span>
                                    </div>
                                </div>
                            }
                            {(type === "checkbox") &&
                                <div className="checkboxlabel">
                                    <div style={{ display: "inline-block", paddingTop: label ? "" : "1.5rem" }}>
                                        {/* <Input  {...input} type={type} name={name} />{' '}<span>{title}</span> */}
                                        {/* <Input  {...input} checked={this.state.isGoing} type={type} name={name} />{' '}<span>{title}</span> */}
                                        {/* {console.log("name checkbox", type, section)} */}


                                        <Row>

                                            {object && object.map((element, index) => {
                                                if (index === 0) {
                                                    return (
                                                        <div style={{ width: "100%", display: "inline-flex" }}>
                                                            <Col lg={size ? size.sub : "4"} md={size ? size.sub : "12"}>
                                                                <input
                                                                    name={section}
                                                                    type={type}
                                                                    className="checkbox"
                                                                    // accept={filetype}
                                                                    onChange={(e) => { this.handleCheckChange(e) }}
                                                                // onChange={event => this.handleCheckChange(name)}
                                                                />{' '}<span>{title}</span>
                                                            </Col>
                                                            <Col lg={size ? size.sub : "4"} md={size ? size.sub : "12"}>

                                                                <input
                                                                    // name={section}
                                                                    type={type}
                                                                    className="checkbox"
                                                                    // accept={filetype}
                                                                    onChange={(e) => { this.handleCheckChange(e, element[keyId]) }}
                                                                // onChange={event => this.handleCheckChange(name)}
                                                                />{' '}<span>{element[keyElement]}</span>

                                                            </Col>
                                                        </div>

                                                    )

                                                }
                                                return (
                                                    <Col lg={size ? size.sub : "4"} md={size ? size.sub : "12"}>

                                                        <input
                                                            // name={section}
                                                            type={type}
                                                            className="checkbox"
                                                            // accept={filetype}
                                                            onChange={(e) => { this.handleCheckChange(e, element[keyId]) }}
                                                        // onChange={event => this.handleCheckChange(name)}
                                                        />{' '}<span>{element[keyElement]}</span>

                                                    </Col>
                                                )

                                            })
                                            }
                                        </Row>



                                    </div>
                                </div>
                            }

                            {/* select Box Input */}
                            {type === "select" &&

                                <Input {...input} placeholder={placeholder} type={type} name={name}
                                    style={{ backgroundColor: this.props.background ? this.props.background : "#eeeeee", borderRadius: '10px' }} >
                                    {optionTitle && <option value={0}>{optionTitle}</option>}
                                    {optioncustom && <option value={optioncustom.value}>{this.props.lang === "ar" ? optioncustom.title.ar : optioncustom.title.en}</option>}
                                    {options ?
                                        options.map((element, index) => {
                                            console.log("Selected Vlaue:", element.value)
                                            return (
                                                <option value={element.value}>{lang === "ar" ? element.title.ar : element.title.en}</option>
                                            )
                                        }) :
                                        object && object.map((element, index) => {
                                            // console.log("children ===>Fields", element, child)
                                            console.log("Selected Vlaue:", element)
                                            if (child && element[child]) {
                                                let childobj = element[child]
                                                console.log("Chilllld:", childobj)
                                                return (
                                                    <option value={parentKey ? element[keyId] : (keyId ? childobj[keyId] : JSON.stringify(element))}>{childobj[keyElement]}</option>
                                                )


                                            }
                                            else {
                                                return (
                                                    <option value={keyId ? element[keyId] : JSON.stringify(element)}>{element[keyElement]}</option>
                                                )
                                            }


                                        })
                                    }
                                </Input>
                            }
                            {/* Text Input */}
                            {type !== "radio" && type !== "select" && type !== "checkbox" && type !== "file" &&
                                <Input min="0" {...input} placeholder={placeholder} type={type} name={name}
                                    value={input.value ? (this.state.object ? this.state.object : input.value) : this.state.object}
                                    style={{ backgroundColor: this.props.background ? this.props.background : "#eeeeee", borderRadius: '10px', display: display }}
                                    onChange={event => this.InputhandleChange(event, input, inputType)}
                                    onKeyPress={event => this.InputhandleChange(event, input, inputType)}
                                />

                            }

                            {type === "file" &&
                                <div className={uploaded === "user" ? "userUpload" : "upload"}>
                                    {console.log("Uploaded Type:", uploaded)}
                                    {uploaded === "user" ?
                                        <img className="btn-file-input" src={this.state.imagePreviewUrl ? (this.state.imagePreviewUrl) :
                                            this.props.imagepreview ?
                                                (API_ENDPOINT + this.props.imagepreview)
                                                : driver} alt="driver" />
                                        :
                                        <img className="btn-file-input-file" src={uploadFileIcone} alt="driver" />
                                        // <i className="fas fa-cloud-upload-alt" style={{ top: "5px", right: "9px", fontSize: "3rem" }}></i>
                                    }

                                    <input
                                        name={input.name}
                                        type={type}
                                        accept={filetype}
                                        onChange={event => this.handleChange(event, input)}
                                    ></input>
                                    {/* {uploaded === "user"&&<i className="fa fa-pen mt-2"></i>}  */}
                                </div>

                            }

                            {icone &&
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className={icone}></i>
                                    </InputGroupText>
                                </InputGroupAddon>
                            }
                        </InputGroup >
                        {/* {console.log("errors message", error)} */}
                        {type === "file" ? <div className="text-center" style={{ marginTop: "30px" }}>
                            {touched && ((error && <span className="mt-3 erroMSG" style={{ color: "red", fontSize: "0.8rem" }}> {lang === "en" ? error.en : error.ar}</span>))}
                        </div> :
                            <div className={lang === "en" ? "LeftAlign" : "RightAlign"} style={{ marginTop: "10px" }}>
                                {touched && ((error && <span className="mt-3 erroMSG" style={{ color: "red", fontSize: "0.8rem" }}> {lang === "en" ? error.en : error.ar}</span>))}
                            </div>
                        }
                    </div>
                </FormGroup>

                {uploaded === "pdf" &&

                    <div>
                        {this.state.imagePreviewUrl ?
                            <div className="imgPreview add-imgPreview">
                                {/* {console.log("pdf preview")} */}
                                {$imagePreview}
                                <i onClick={() => this.setState({ imagePreviewUrl: null, file: null })} className={uploaded === "image" ? "fa fa-window-close close" : "fa fa-window-close"}></i>
                            </div> :
                            <div className="imgPreview add-imgPreview" style={{ display: this.state.uploadedfile ? "none" : "inline-block" }}>
                                {/* {console.log("pdf preview")} */}
                                {this.props.Fileimagepreview}
                                {/* <i onClick={() => this.setState({ imagePreviewUrl: null, file: null,uploadedfile:true })} className={uploaded === "image" ? "fa fa-window-close close" : "fa fa-window-close"}></i> */}
                            </div>
                        }
                    </div>




                }
            </Col>
        )
    }

}
const mapStateToProps = state => {
    return {
        token: state.login.token,
        language: state.lang.lang

    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        showLoading,
        hideLoading

    }
    , dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(CustomInput)

